// GraphQL queries for the new metering page. See xwatts_api/gql for the schema.

export const TIME_AGG = {
    h: "HOUR",
    d: "DAY",
    m: "MONTH",
    q: "QUARTER",
    y: "YEAR",
};

// Selector headings, in display order. Group types match the API's GroupType.
export const HEADINGS = {
    FACILITY: "Facility",
    LOCATION: "Location",
    SYSTEM: "System",
    OTHER: "Other",
    TARIFF: "Tariff",
};

// The facility's relay ID, from its REST URL.
export const facilityGlobalId = (facility) =>
    btoa(`Facility:${facility.split("/").slice(-2)[0]}`);

export const OPTIONS_QUERY = `
query MeteringOptions($facility: ID!) {
  node(id: $facility) {
    ... on Facility {
      id
      name
      groups(first: 1000) {
        edges { node { id name type } }
      }
    }
  }
  metering {
    tariffs(first: 1000, filters: { facility: { id: [$facility] } }) {
      edges { node { id name } }
    }
  }
}`;

// Facility sums are always fetched for the summary card. An empty ID list
// returns no groups or tariffs.
export const SUMS_QUERY = `
query MeteringSums(
  $facility: ID!
  $groups: [ID!]!
  $groupCount: Int!
  $tariffs: [ID!]!
  $tariffCount: Int!
  $from: DateTime!
  $to: DateTime!
  $timeAgg: TimeAgg!
) {
  node(id: $facility) {
    ... on Facility {
      id
      name
      calculatedHourlyEnergyDataSums(from: $from, to: $to, timeAgg: $timeAgg) {
        from
        consumptionKwh
        cost
        co2Kg
      }
      groups(first: $groupCount, filters: { id: $groups }) {
        edges {
          node {
            id
            name
            type
            calculatedHourlyEnergyDataSums(from: $from, to: $to, timeAgg: $timeAgg) {
              from
              consumptionKwh
              cost
              co2Kg
            }
          }
        }
      }
    }
  }
  metering {
    tariffs(first: $tariffCount, filters: { id: $tariffs }) {
      edges {
        node {
          id
          name
          energyPriceMeans(from: $from, to: $to, timeAgg: $timeAgg) {
            from
            value
          }
        }
      }
    }
  }
}`;

// Portfolio view: every visible facility. Root facilities has no filters, so
// all their sums come back; the summary card needs them all anyway.
export const PORTFOLIO_OPTIONS_QUERY = `
query MeteringPortfolioOptions {
  facilities(first: 1000) {
    edges { node { id name } }
  }
  groups(first: 1000) {
    edges { node { id name type facility { name } } }
  }
  metering {
    tariffs(first: 1000) {
      edges { node { id name facility { name } } }
    }
  }
}`;

export const PORTFOLIO_SUMS_QUERY = `
query MeteringPortfolioSums(
  $facilityCount: Int!
  $groups: [ID!]!
  $groupCount: Int!
  $tariffs: [ID!]!
  $tariffCount: Int!
  $from: DateTime!
  $to: DateTime!
  $timeAgg: TimeAgg!
) {
  facilities(first: $facilityCount) {
    edges {
      node {
        id
        name
        calculatedHourlyEnergyDataSums(from: $from, to: $to, timeAgg: $timeAgg) {
          from
          consumptionKwh
          cost
          co2Kg
        }
      }
    }
  }
  groups(first: $groupCount, filters: { id: $groups }) {
    edges {
      node {
        id
        name
        type
        calculatedHourlyEnergyDataSums(from: $from, to: $to, timeAgg: $timeAgg) {
          from
          consumptionKwh
          cost
          co2Kg
        }
      }
    }
  }
  metering {
    tariffs(first: $tariffCount, filters: { id: $tariffs }) {
      edges {
        node {
          id
          name
          energyPriceMeans(from: $from, to: $to, timeAgg: $timeAgg) {
            from
            value
          }
        }
      }
    }
  }
}`;
